import { render, staticRenderFns } from "./AddBrandComponent.vue?vue&type=template&id=271f74d3"
import script from "./AddBrandComponent.vue?vue&type=script&lang=ts"
export * from "./AddBrandComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports